import React from "react";
import Social from "../components/Social";
import blr1 from "../assets/blurs01.svg"
import blr2 from "../assets/blurs02.svg"
import Card from "../components/Card";
import Header from "../components/Header";
import swtch from '../assets/switch.svg';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import {motion, AnimatePresence } from "framer-motion";
import {useEffect} from 'react';
import Cursor from "../components/CursorBall"

import sande from '../assets/card/proj (1).webp'
import vongo from '../assets/card/proj (2).webp'
import betfeed from '../assets/card/proj (3).webp'
import dx from '../assets/card/proj (4).webp'
import chat from '../assets/card/proj (5).webp'
import ewms from '../assets/card/proj (7).webp'
import livcrik from '../assets/card/proj (8).webp'
import hp from '../assets/card/proj (9).webp'
import hostel from '../assets/card/proj (10).webp'
import arrl from '../assets/arrowl.svg'
import arrr from '../assets/arrowr.svg'


const Projects = () => {

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);
    

    const card = [
        {"img":sande,"title":"SandE","year":"2022"},
        {"img":vongo,"title":"Vongo","year":"2021"},
        {"img":betfeed,"title":"Betterfeeds","year":"2022"},
        {"img":dx,"title":"DevignX","year":"2022"},
        {"img":chat,"title":"ChatRT","year":"2021"},
        {"img":ewms,"title":"EWMS","year":"2022"},
        {"img":livcrik,"title":"LivCricket","year":"2021"},
        {"img":hp,"title":"Hari Prasad","year":"2022"},
        {"img":hostel,"title":"Hostel Management","year":"2022"},
    ]
    
    return(
            <div>
            <Cursor/>
                <motion.button
                    whileHover={{scale:1.1, color:'white', backgroundColor:'transparent', transition:{duration:1}}}
                    whileTap={{scale:0.8, color:'white', backgroundColor:'transparent'}}
                    transition={{duration:0.4}}
                    className="p-4 toppp fixed text-xl bottom-[40px] right-[40px]  text-black text-center rounded-full bg-white"
                    onClick={() => {
                    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});}}>
                ↑</motion.button>
                <Header/>
            <AnimatePresence>
            <motion.div 
            key="proj"
            initial={{opacity:0}}
            animate={{opacity:1}}
            exit={{opacity:0, transition:{duration:5}}}
            transition={{duration:1, ease:"easeInOut"}}>

                <Helmet>
                    <title>Hari Prasad's Projects</title>
                    <meta
                    name="description"
                    content="Projects that showcase Creative Design & Solid Development"
                    />
                    <meta
                    name="keywords"
                    content="design, uiux, code, creative, frontend, dev, brand"
                    />
                </Helmet>
                
                <div className="-mt-[6rem] md:-mt-[8.1rem]">
                
                    <div className="pc flex text-slate-300 text-md font-light flex-row gap-10 justify-end p-5 m-6 mx-8">
                        <Link to ="/"><h2 className="hover:text-white cursor-pointer"><abbr title="About me in short">ABOUT</abbr></h2></Link>
                        <Link to = "/projects"><h2 className="font-normal text-white"><abbr title="List of projects, I've worked on">PROJECTS</abbr><div className="hr"></div></h2></Link>
                            <Link to ="/random"><h2 className="hover:text-white"><abbr title="ever seen a 404 page in Navbar?">404 😜</abbr></h2></Link>
                    </div>
                        <div className="mob flex items-center text-slate-400 font-light flex-row gap-4 justify-start p-5 m-2 mx-5">
                            <h2 className="text-sm"><Link to="/"><p className="text-lg font-normal text-slate-300">ABOUT</p></Link> </h2>
                            <p>•</p>
                            <h2 className="text-sm"><br></br> <p className="text-lg font-normal text-white">PROJECTS</p><div className="hr"/></h2>
                        </div>

                    <motion.section
                    initial={{rotateZ:30, opacity:0, x:-10}}
                    animate={{rotateZ:0,opacity:1, x:0}}
                    transition={{ duration: 0.3 }}

                    className=" md: p-2 mb-3 mx-8">
                        <p className="text-sm font-light pt-5 text-slate-300">Projects as a</p>
                        <div className="flex flex-row items-center gap-2 cursor-pointer w-fit">
                            <motion.p whileTap={{scale:0.9}} className=" text-3xl text-white pt-1 font-semibold"><abbr title="Click to switch">DESIGNER</abbr></motion.p>
                            <motion.img
                    initial={{rotateY:0}}
                    whileTap={{ rotateY:90}}
                            className=" pt-[.2rem] w-[1.5rem]" src={swtch} alt='switch'/>
                        </div>
                    </motion.section>
                    </div>

                    
            </motion.div>
            </AnimatePresence>
            
            <div className="flex flex-col md:flex-row items-center pb-[5rem] mt-[3rem] gap-5 overflow-x-scroll">
                        <div className='absolute pc opacity-40 flex justify-between w-full toppp'>
                            <img className= 'noselect w-[2rem]' src={arrl} alt='arrows'></img>
                            <img className= 'noselect w-[2rem]' src={arrr} alt='arrows'></img>
                        </div>
                        {
                            card.map((card, index) => {
                                return <Card key={index} image={card.img} title={card.title} year={card.year}/>
                            })
                        }
                    </div>
                    
                
                <Social/>
            
                <div className="pointer-events-none ">
                    <img draggable="false" className="fixed bottom-[30%] noselect -left-40 md:-left-40 w-[50rem] blur-lg -z-[999]" src={blr2} rel="preload" alt='blur'></img>
                    <img draggable="false" className="fixed -bottom-[0%] noselect  -right-40 md:-right-20 -bottom-[20%] w-[50rem] blur-lg -z-[999] " src={blr1} rel="preload" alt='blur'></img>
                </div>
            </div>
    )
}

export default Projects;